export default __webpack_public_path__ + "static/media/thelaststand.98019aa0.png";